/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import styled from 'styled-components';

import { ScrollbarStyled } from '@components/common/Scrollbar/ScrollbarStyled';
import { TextContainerStyled } from '@components/common/TextBlock/styled/TextBlockStyled';
import { fonts } from '@theme/index';

export const TableTooltipOuterBlockStyled = styled.div.attrs({
    className: 'table-tooltip_outer-block',
})`
    position: fixed;
    top: 0;
    left: 0;
    height: max-content;
    max-height: 300px;
    width: max-content;
    max-width: 300px;
    overflow-wrap: break-word;
    overflow-y: auto;
    box-shadow: 0 0 12px 0 rgba(51, 51, 51, 0.2);
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1) 100ms, transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    ${fonts.textMain};
    ${ScrollbarStyled};

    &::-webkit-scrollbar {
        width: 8px;
    }

    &.visible,
    &:hover {
        visibility: visible;
        opacity: 1;
        transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 100ms, transform 133ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
`;

export const TableTooltipInnerBlockStyled = styled.div.attrs({
    className: 'table-tooltip_inner-block',
})`
    padding: 16px 20px;
    position: relative;
    max-width: 100%;
    box-shadow: 0 0 12px 0 rgba(51, 51, 51, 0.2);
    box-sizing: border-box;
    border-radius: 0;
    background-color: white;
    & ${TextContainerStyled} {
        word-break: break-word;
    }
`;

export const TableTooltipArrowStyled = styled.span`
    position: absolute;
    left: calc(50% - 1.5em);
    width: 3em;
    bottom: -6px;
    height: 1em;
    font-size: 6px;
    &:before {
        width: 0;
        height: 0;
        margin: auto;
        content: "";
        display: block;
        border-style: solid;
        border-color: white transparent transparent transparent;
        border-width: 1em 1em 0 1em;
    }
`;
